import { useContext } from 'react'

import { MixerContext } from './MixerProvider'

export const useMixer = () => {
  const context = useContext(MixerContext)

  if (context === undefined) {
    throw new Error('useMixer must be used within a MixerProvider')
  }

  return context
}
